import { render, staticRenderFns } from "./free-response.vue?vue&type=template&id=5c5f09ee&scoped=true"
import script from "./free-response.ts?vue&type=script&lang=ts&external"
export * from "./free-response.ts?vue&type=script&lang=ts&external"
import style0 from "./free-response.scss?vue&type=style&index=0&id=5c5f09ee&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f09ee",
  null
  
)

export default component.exports